import React from 'react';
import './MentionsLegales.css';

const MentionsLegales = () => {
  return (
    <div className="mentions-legales-container">
      <div className="mentions-legales-content">
        <h1 className="mentions-title">Mentions Légales</h1>

        <section className="mentions-section">
          <h2>Éditeur du site</h2>
          <p>
            <strong>Les Tontons Friteurs</strong><br />
            B.P.101<br></br>
            59280 Armentières<br></br>
            Siret : 48928062800012<br />
            {/* Téléphone : 07 70 29 39 81<br /> */}
            {/* Email :  les.tontons.friteurs@hotmail.fr */}
          </p>
          <p>
            {/* <strong>Directeur de la publication</strong> : Franck Lamy */}
          </p>

        </section>

        <section className="mentions-section">
          <h2>Hébergement</h2>
          <p>
            Ce site est hébergé par :<br />
            <strong>byethost7.com</strong><br />
            Royaume-Unis<br />
            Site web : https://byet.host/<br></br>
            Nom de domaine: les-tontons-friteurs.fr est la propriété de la société: Les Tontons Friteurs
          </p>
        </section>

        <section className="mentions-section">
           <h2>Développement du site</h2>
            <p>
              Ce site a été développé par <strong>Franck Lamy</strong>.<br />
              Site web :             <a href='http://webdev.francklamy.com/' target='_blanks'>http://webdev.francklamy.com/</a>
            </p>
        </section>

        <section className="mentions-section">
          <h2>Propriété intellectuelle</h2>
          <p>
            L'ensemble du contenu du site (textes, images, logos, vidéos, code source du site, etc.) est protégé par les lois françaises et internationales sur la propriété intellectuelle.
            Toute reproduction, représentation, modification, publication, adaptation totale ou partielle des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de l'éditeur.
          </p>
        </section>

        <section className="mentions-section">
          <h2>Données personnelles</h2>
          <p>
            Les données personnelles recueillies sur ce site sont traitées conformément au Règlement Général sur la Protection des Données (RGPD).
            Elles sont utilisées uniquement dans le cadre de la gestion des relations clients et ne sont pas transmises à des tiers.
            Vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles.
            Pour exercer ce droit, contactez-nous à : contact@tontonsfriteurs.fr.
          </p>
        </section>

        <section className="mentions-section">
          <h2>Cookies</h2>
          <p>
            Ce site utilise des cookies pour améliorer l'expérience utilisateur.
            En navigant sur ce site, vous acceptez notre politique d'utilisation des cookies.
          </p>
        </section>

        <section className="mentions-section">
          <h2>Liens externes</h2>
          <p>
            Notre site peut contenir des liens vers d'autres sites web.
            Nous ne sommes pas responsables du contenu ou des pratiques de ces sites tiers.
          </p>
        </section>

        <section className="mentions-section">
          <h2>Contact</h2>
          <p>
            Pour toute question concernant les mentions légales, vous pouvez nous contacter via notre formulaire de contact.
          </p>
        </section>

        <div className="mentions-footer">
          <p>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
